import { useNavigate } from "react-router-dom";
import { useProfileCompletion } from "../../../lib/react-query/profile";
import { Button } from "../../shared/Button";
import {
  HiOutlinePlus,
  HiOutlineUser,
  HiOutlineChatBubbleLeftRight,
} from "react-icons/hi2";

const QuickActions = () => {
  const navigate = useNavigate();
  const { data: profileData } = useProfileCompletion(true);

  const profileCompletion = profileData?.percentage || 0;
  const showOnboarding = profileCompletion <= 90;

  const actions = [
    {
      id: "project",
      label: "New Project",
      icon: HiOutlinePlus,
      onClick: () => navigate("/projects"),
      // Primary action: the only filled button in the quick-action system.
      variant: "filled",
      color: "secondary",
    },
    {
      id: "task",
      label: "Add Task",
      icon: HiOutlinePlus,
      onClick: () => navigate("/tasks"),
      // Secondary action: outlined.
      variant: "outlined",
      color: "secondary",
    },
    ...(showOnboarding
      ? [
          {
            id: "onboarding",
            label: "Complete Onboarding",
            icon: HiOutlineUser,
            onClick: () => navigate("/profile"),
            // Secondary action: outlined.
            variant: "outlined",
            color: "secondary",
          },
        ]
      : []),
    {
      id: "chat",
      label: "Open Chat",
      icon: HiOutlineChatBubbleLeftRight,
      onClick: () => navigate("/chat"),
      // Secondary action: outlined.
      variant: "outlined",
      color: "secondary",
    },
  ];

  return (
    <div className="bg-white rounded-2xl p-5 shadow-sm border border-surface-border">
      <h3 className="text-sm font-medium text-mediumgrey mb-4">Quick Actions</h3>
      <div className="flex flex-wrap gap-3">
        {actions.map((action) => (
          <div key={action.id} className="relative group">
            <Button
              onClick={action.onClick}
              variant={action.variant}
              color={action.color}
              size="md"
              icon={action.icon}
              className="gap-2 focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-secondary focus-visible:outline-none"
            >
              {action.label}
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;
